import { defineMessages } from 'react-intl';

export const adyenMessages = defineMessages({
  cardNumber: {
    id: 'checkout.cartPage.adyen.cardNumber',
    defaultMessage: 'Card number',
  },
  cardHolder: {
    id: 'checkout.cartPage.adyen.cardholderName',
    defaultMessage: "Cardholder's name",
  },
  expiration: {
    id: 'checkout.cartPage.adyen.cardExpirationDate',
    defaultMessage: 'Expiration date',
  },
  cvvNumber: {
    id: 'checkout.cartPage.adyen.securityCode',
    defaultMessage: 'Security code',
  },
  invalidCardNumber: {
    id: 'checkout.cartPage.adyen.invalidCardNumber',
    defaultMessage: 'Incorrect format of credit card number.',
  },
  payButton: {
    id: 'checkout.cartPage.adyen.payButton',
    defaultMessage: 'Pay',
  },
  title: {
    id: 'checkout.cartPage.adyen.cardPayment',
    defaultMessage: 'Safe card payment',
  },
  totalOrderPrice: {
    id: 'checkout.cartPage.adyen.totalPrice',
    defaultMessage: 'Total',
  },
  paymentErrorMessage: {
    id: 'checkout.cartPage.adyen.paymentFailed',
    defaultMessage: '3D Secure authentication was not executed, or it did not execute successfully',
  },
  changePaymentMethod: {
    id: 'checkout.cartPage.adyen.changePaymentMethod',
    defaultMessage: 'I want to use a different card',
  },
  selectStoredPaymentMethod: {
    id: 'checkout.cartPage.adyen.selectStoredPaymentMethodTitle',
    defaultMessage: 'Select one of your saved cards',
  },
  rememberCard: {
    id: 'checkout.cartPage.adyen.rememberCard',
    defaultMessage: 'Save card for your next purchase',
  },
  securedPayment: {
    id: 'checkout.cartPage.adyen.securedPayment',
    defaultMessage: 'This payment is secured',
  },
  rememberCardInfoText: {
    id: 'checkout.cartPage.adyen.rememberCardInfoText',
    defaultMessage:
      'Your card details will be stored with Adyen, a certified payment gateway, and Notino does not have access to these details.',
  },
  idealPaymentTitle: {
    id: 'checkout.cartPage.adyen.idealPaymentTitle',
    defaultMessage: 'Ideal Payment',
  },
  swishPaymentTitle: {
    id: 'checkout.cartPage.adyen.swishPaymentTitle',
    defaultMessage: 'Swish Payment',
  },
  twintPaymentTitle: {
    id: 'checkout.cartPage.adyen.twintPaymentTitle',
    defaultMessage: 'Twint Payment',
  },
  blikPaymentTitle: {
    id: 'checkout.cartPage.adyen.blikPaymentTitle',
    defaultMessage: 'Blik Payment',
  },
  mbWayPaymentTitle: {
    id: 'checkout.cartPage.adyen.mbWayPaymentTitle',
    defaultMessage: 'MB WAY Payment',
  },
  securedPaymentInfo: {
    id: 'checkout.cartPage.adyen.securedPaymentInfo',
    defaultMessage: 'Your payment information are secured',
  },
  incorrectCreditCardFormat: {
    id: 'checkout.cartPage.adyen.incorrectCreditCardFormat',
    defaultMessage: 'Incorrect format of credit card number.',
  },
  cardHolderPlaceholder: {
    id: 'checkout.cartPage.adyen.cardHolderPlaceholder',
    defaultMessage: 'J. Smith',
  },
  unsupportedCard: {
    id: 'checkout.cartPage.adyen.unsupportedCard',
    defaultMessage: 'Unsupported card',
  },
  oldCard: {
    id: 'checkout.cartPage.adyen.oldCard',
    defaultMessage: 'Old card',
  },
  dateInFuture: {
    id: 'checkout.cartPage.adyen.dateInFuture',
    defaultMessage: 'Date far in the future',
  },
  cardWillExpire: {
    id: 'checkout.cartPage.adyen.cardWillExpire',
    defaultMessage: 'Card will expire before the end of the transaction',
  },
  incompleteData: {
    id: 'checkout.cartPage.adyen.incompleteData',
    defaultMessage: 'Incomplete data',
  },
  invalidData: {
    id: 'checkout.cartPage.adyen.invalidData',
    defaultMessage: 'Invalid data',
  },
  enterCardNumber: {
    id: 'checkout.cartPage.adyen.enterCardNumber',
    defaultMessage: '',
  },
  enterExpirationDate: {
    id: 'checkout.cartPage.adyen.enterExpirationDate',
    defaultMessage: '',
  },
  enterSecurityCode: {
    id: 'checkout.cartPage.adyen.enterSecurityCode',
    defaultMessage: '',
  },
  enterFullExpirationDate: {
    id: 'checkout.cartPage.adyen.enterFullExpirationDate',
    defaultMessage: '',
  },
  allFieldsAreRequired: {
    id: 'checkout.cartPage.adyen.allFieldsAreRequired',
    defaultMessage: '',
  },
  enterFulLSecurityCode: {
    id: 'checkout.cartPage.adyen.enterFulLSecurityCode',
    defaultMessage: '',
  },
  enterFullCardNumber: {
    id: 'checkout.cartPage.adyen.enterFullCardNumber',
    defaultMessage: '',
  },
  mobilePayPaymentTitle: {
    id: 'checkout.cartPage.adyen.mobilePayPaymentTitle',
    defaultMessage: 'MobilePay Payment',
  },
  bcMobilePaymentTitle: {
    id: 'checkout.cartPage.adyen.bcMobilePaymentTitle',
    defaultMessage: 'Bancontact Mobile Payment',
  },
  cardNumberPlaceHolder: {
    id: 'checkout.cartPage.adyen.cardNumberPlaceHolder',
    defaultMessage: '1234 5678 9012 3456',
  },
  cvvPlaceHolder: {
    id: 'checkout.cartPage.adyen.cvvPlaceHolder',
    defaultMessage: '3 digits',
  },
  expiryDatePlaceHolder: {
    id: 'checkout.cartPage.adyen.expiryDatePlaceHolder',
    defaultMessage: 'MM/RR',
  },
  blikCodePlaceHolder: {
    id: 'checkout.cartPage.adyen.blikCodePlaceHolder',
    defaultMessage: '123456',
  },
  mbWayCodePlaceHolder: {
    id: 'checkout.cartPage.adyen.mbWayCodePlaceHolder',
    defaultMessage: '932123456',
  },
});
